import { TOOLBAR_BUTTON_SX } from "@/controls/buttons/toolbarButton";
import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";
import { MillSizeSelector } from "./MillSizeSelector";

interface CartridgesToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	millSizeId: number | null;
	onMillSizeChange: (value: number | null) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
	onReset: () => void;
	canReset: boolean;
}

export const CartridgesToolbar = ({
	search,
	onSearchChange,
	millSizeId,
	onMillSizeChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
	onReset,
	canReset,
}: CartridgesToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				flexWrap: "wrap",
				px: 1.5,
				py: 0.75,
			}}
		>
			<TextField
				size="small"
				placeholder="Search..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 200 }}
			/>

			<MillSizeSelector
				value={millSizeId}
				onChange={onMillSizeChange}
				includeAll
				size="small"
				sx={{ width: 130 }}
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<ResetFiltersButton onClick={onReset} disabled={!canReset} />

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="medium"
				sx={{ ...TOOLBAR_BUTTON_SX, whiteSpace: "nowrap" }}
			>
				Add Cartridge
			</Button>
		</Box>
	);
};
